import { FC, useEffect, useRef } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import videoTooltipElementShown from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/video_tooltip_element_shown';
import { BottomSheet, NavBar, Text, Tooltip } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { useSelector } from 'store/utils';

import styles from 'components/common/BannerVideo/BannerVideoTitle/BannerVideoTitle.module.less';

const IS_BANNER_VIDEO_TIP_WAS_SHOWN = 'IS_BANNER_VIDEO_TIP_WAS_SHOWN';

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerVideo.title',
    tooltip: 'AdCreate.AdForm.BannerVideo.title.tooltip',
};

export const BannerVideoTitle: FC = () => {
    const [isShowInfo, setShowInfoOn, setShowInfoOff] = useOnOffState(
        !LocalStorageWrapper.getItem(IS_BANNER_VIDEO_TIP_WAS_SHOWN)
    );
    const trl = useTrls();

    const bannerVideoTitleRef = useRef<HTMLDivElement>(null);
    const bannerVacancyId = useSelector((state) => state.createBanner.bannerVacancyId);
    const vacancyId = bannerVacancyId ? String(bannerVacancyId) : null;

    useEffect(() => {
        LocalStorageWrapper.setItem(IS_BANNER_VIDEO_TIP_WAS_SHOWN, 'true');
    }, []);

    const tooltipActivatorRef = useRef<HTMLDivElement>(null);

    const tooltipContent = (
        <ElementShownAnchor fn={videoTooltipElementShown} vacancyId={vacancyId}>
            <Text>{trl(TrlKeys.tooltip)}</Text>
        </ElementShownAnchor>
    );

    return (
        <div className={styles.uploadFieldTitleContainer} ref={bannerVideoTitleRef}>
            <Text Element="span" typography="label-2-regular" style="secondary">
                {trl(TrlKeys.title)}
            </Text>
            <span className={styles.titleIcon}>
                <QuestionCircleOutlinedSize16
                    ref={tooltipActivatorRef}
                    initialColor="secondary"
                    onClick={() => {
                        setShowInfoOn();
                    }}
                />
            </span>
            <Tooltip
                placement="right-center"
                activatorRef={tooltipActivatorRef}
                maxWidth={280}
                visible={isShowInfo}
                onClose={() => setShowInfoOff()}
            >
                {tooltipContent}
            </Tooltip>
            <BottomSheet
                visible={isShowInfo}
                onClose={setShowInfoOff}
                header={
                    <NavBar>
                        <NavBar.Pane>
                            <NavBar.Stage>
                                <NavBar.Actions centered>
                                    <NavBar.TitleContainer
                                        centered
                                        title={<Text typography="subtitle-1-semibold">{trl(TrlKeys.title)}</Text>}
                                    />
                                </NavBar.Actions>
                            </NavBar.Stage>
                        </NavBar.Pane>
                    </NavBar>
                }
            >
                {tooltipContent}
            </BottomSheet>
        </div>
    );
};
